import { existsFilter, termFilter } from './filters'

import type { TermsClause, WildcardClause } from '../types/query'

export { existsFilter, termFilter }

/**
 * Terms filter — matches any of a list of values.
 */
export function termsFilter(
	field: string,
	values: ReadonlyArray<unknown>,
): TermsClause {
	return { terms: { [field]: [...values] } }
}

/**
 * Wildcard filter — `*foo*`, `foo*`, `*foo` patterns.
 * Case-insensitive by default.
 */
export function wildcardFilter(
	field: string,
	value: string,
	caseInsensitive = true,
): WildcardClause {
	return {
		wildcard: {
			[field]: {
				value,
				...(caseInsensitive && { case_insensitive: true }),
			},
		},
	}
}
